export default __webpack_public_path__ + "static/logo5-35b8cca583fc44ff40d46482d5871ea3.svg";